import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Table } from 'components/HeroSemantic';

class TableWrapper extends Component {
  static propTypes = {
    client: PropTypes.object.isRequired,
    headers: PropTypes.array.isRequired,
    body: PropTypes.array.isRequired,
    footer: PropTypes.array,
  };

  render() {
    const { client, headers, body, footer } = this.props;
    // Tables in 700-768px window behaved oddly in tablet mode in the legacy markup, so we
    // keep that range in the mobile branch as well.
    const isMobile = client.screenType === 'mobile' || (client.screenWidth && client.screenWidth < 768);

    if (isMobile) {
      return (
        <div className="mx-auto my-5 flex flex-col gap-3" style={{ maxWidth: '1100px' }}>
          {
            body.map(row => (
              <div
                key={row.id}
                className="rounded-lg border border-[var(--owner-border)] bg-[var(--owner-surface)] p-4 shadow-sm"
              >
                <dl className="grid grid-cols-1 gap-2 text-sm leading-6">
                  {
                    row.content.map((cell, index) => (
                      <div key={headers?.[index]?.id || `cell-${index}`} className="flex flex-col gap-0.5">
                        <dt className="text-[11px] font-semibold uppercase tracking-[0.04em] text-[var(--owner-text-muted)]">
                          {headers?.[index]?.content || ''}
                        </dt>
                        <dd className="m-0 break-words text-[var(--owner-text)]">{cell}</dd>
                      </div>
                    ))
                  }
                </dl>
              </div>
            ))
          }
          {
            footer && footer.length > 0 && (
              <div className="rounded-lg border border-[var(--owner-border)] bg-[var(--owner-surface-muted)] p-4 shadow-sm">
                <dl className="grid grid-cols-1 gap-2 text-sm leading-6">
                  {
                    footer.map(f => (
                      <div key={f.id} className="flex flex-col gap-0.5">
                        <dt className="text-[11px] font-semibold uppercase tracking-[0.04em] text-[var(--owner-text-muted)]">
                          {f.title || (
                            <span>
                              <FormattedMessage id="general.total" />
                              { typeof f.index === 'number' && headers[f.index] && headers[f.index].content }
                            </span>
                          )}
                        </dt>
                        <dd className="m-0 font-bold text-[var(--owner-text)]">{f.content}</dd>
                      </div>
                    ))
                  }
                </dl>
              </div>
            )
          }
        </div>
      );
    }

    return (
      <Table basic="very" size="large" style={{ maxWidth: '1100px', margin: '20px auto' }}>
        <Table.Header>
          <Table.Row>
            { headers.map(header => <Table.HeaderCell width={header.width} key={header.id}>{header.content}</Table.HeaderCell>) }
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            body.map(row => (
              <Table.Row key={row.id}>
                { row.content.map((cell, index) => <Table.Cell key={`${headers?.[index]?.id || `cell-${index}`}${cell}`}>{cell}</Table.Cell>) }
              </Table.Row>
            ))
          }
        </Table.Body>
        <Table.Footer>
          <Table.Row>
            {
              footer && footer.map(f => (
                <Table.Cell key={f.id} colSpan={f.colSpan} style={{ fontWeight: 'bold' }}>
                  {f.title}
                  {f.title ? ': ' : ''}
                  {f.content}
                </Table.Cell>
              ))
            }
          </Table.Row>
        </Table.Footer>
      </Table>
    );
  }
}

export default connect(state => ({ client: state.client }))(TableWrapper);
